import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import ClearIcon from '@material-ui/icons/Clear';
import SelectReact from 'react-select';
import Modal from '@material-ui/core/Modal';

import i18n from '../../i18n';
import SimpleDialogFragment from './SimpleDialogFragment';
import '../../assets/stylesheets/Setting.css';
import { positionAttributeTypeOptions } from '../../constants/general';
import GenericDeleteModal from './GenericDeleteModal';
import GenericWarningModal from './GenericWarningModal';

class EditAttributeModal extends Component {
  constructor(props) {
    super(props);

    const { positionAttributeData } = this.props;

    this.state = {
      positionAttributes: positionAttributeData.attributeControls,
      attributeTypeOptions: [],
      showDeleteModal: false,
      showWarningModal: false,
      deleteIndex: 0,
      initialPositionAttributeData: positionAttributeData.attributeControls
    };
  }

  showDeleteModal = index => {
    this.setState({ showDeleteModal: true, deleteIndex: index });
  };

  hideDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  showWarningModal = () => {
    this.setState({ showWarningModal: true });
  };

  hideWarningModal = () => {
    this.setState({ showWarningModal: false });
  };

  handleNameChange = (value, index) => {
    const { positionAttributes } = this.state;

    const attributeData = JSON.parse(JSON.stringify(positionAttributes));
    attributeData[index].attributeName = value;

    this.setState({ positionAttributes: attributeData });
  };

  handleAttributeTypeChange = (type, index) => {
    const { positionAttributes } = this.state;

    const attributeData = JSON.parse(JSON.stringify(positionAttributes));
    attributeData[index].valueType = type.value;

    this.setState({ positionAttributes: attributeData });
  };

  handleDisplayInBookingTableChange = index => {
    const { positionAttributes } = this.state;

    const attributeData = JSON.parse(JSON.stringify(positionAttributes));
    attributeData[index].displayInBookingTable = !attributeData[index]
      .displayInBookingTable;

    this.setState({ positionAttributes: attributeData });
  };

  handleDeleteRow = index => {
    const { positionAttributes, initialPositionAttributeData } = this.state;

    const attributeData = JSON.parse(JSON.stringify(positionAttributes));

    const attributeStatus = JSON.parse(
      JSON.stringify(initialPositionAttributeData)
    );

    if (attributeData[index].id !== undefined) {
      attributeStatus[index].status = 'deleted';
    }

    // We splice to delete the designated row
    attributeData.splice(index, 1);

    this.setState({
      positionAttributes: attributeData,
      deleteIndex: 0,
      initialPositionAttributeData: attributeStatus
    });

    this.hideDeleteModal();
  };

  handleAddNewRow = () => {
    const { positionAttributes } = this.state;

    const attributeData = JSON.parse(JSON.stringify(positionAttributes));
    attributeData.push({
      attributeName: '',
      valueType: 'boolean',
      status: 'added',
      displayInBookingTable: true
    });

    this.setState({ positionAttributes: attributeData });
  };

  componentDidMount = () => {
    this.buildAttributeTypeOptions();
  };

  handleCancelEdit = () => {
    const { hideModal } = this.props;

    this.setState(prevState => {
      return { positionAttributes: prevState.initialPositionAttributeData }
    });

    hideModal();
  };

  buildAttributeTypeOptions = () => {
    const attributeTypeOptions = Object.keys(positionAttributeTypeOptions).map(value =>
      ({
        id: value,
        label: i18n.t(`booking:${positionAttributeTypeOptions[value].type}`),
        value: positionAttributeTypeOptions[value].type
      })
    );

    this.setState({ attributeTypeOptions });
  };

  onSubmit = () => {
    const { positionAttributeData, editAttribute, hideModal } = this.props;
    const { positionAttributes, initialPositionAttributeData } = this.state;

    let hasEmptyName = false;
    Object.keys(positionAttributes).forEach(index => {
      if (positionAttributes[index].attributeName === '') {
        hasEmptyName = true;
      }
    });

    if (hasEmptyName) {
      this.showWarningModal();
    } else {
      editAttribute(
        positionAttributeData.id,
        positionAttributeData.positionName,
        positionAttributes,
        initialPositionAttributeData
      );
      hideModal();
    }
  };

  retrievePositionAttributeType = type => {
    const { attributeTypeOptions } = this.state;

    switch (type) {
      case 'boolean':
        return attributeTypeOptions[0];
      case 'string':
        return attributeTypeOptions[1];
      case 'site':
        return attributeTypeOptions[2];
      case 'image':
        return attributeTypeOptions[3];
      case 'date':
        return attributeTypeOptions[4];
      default:
        return attributeTypeOptions[0];
    }
  };

  render() {
    const {
      showModal,
      hideModal,
      selectedValidPosition,
      positionAttributeData
    } = this.props;
    const {
      positionAttributes,
      attributeTypeOptions,
      showDeleteModal,
      showWarningModal,
      deleteIndex
    } = this.state;

    return (
      <Modal open={showModal} onClose={hideModal}>
        <Paper className="editAttributeModal">
          {selectedValidPosition == null || selectedValidPosition === -1 ? (
            <SimpleDialogFragment
              title={i18n.t('setting:warningAttributeModal')}
              buttonLabel={i18n.t('close')}
              onClick={hideModal}
            />
          ) : (
            <div>
              <span>
                {i18n.t(`positions:${positionAttributeData.positionName}`)}
              </span>
              <Divider />
              <br />
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>{i18n.t('setting:attributeName')}</TableCell>
                    <TableCell>{i18n.t('setting:attributeType')}</TableCell>
                    <TableCell>
                      {i18n.t('setting:displayInBookingTable')}
                    </TableCell>
                    <TableCell>
                      <DeleteIcon />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(positionAttributes).map(index => {
                    const localeAttributeName = i18n.t(
                      `booking:${positionAttributes[deleteIndex].attributeName}`
                    )
                    return (
                      <React.Fragment key={index}>
                        <TableRow key={index}>
                          <TableCell component="th" scope="row">
                            <TextField
                              fullWidth
                              value={i18n.t(
                                `booking:${positionAttributes[index].attributeName}`
                              )}
                              onChange={event =>
                                this.handleNameChange(event.target.value, index)
                              }
                            />
                          </TableCell>
                          <TableCell>
                            <SelectReact
                              fullWidth
                              value={this.retrievePositionAttributeType(
                                  positionAttributes[index].valueType
                                )
                              }
                              options={attributeTypeOptions}
                              onChange={event =>
                                this.handleAttributeTypeChange(event, index)
                              }
                            />
                          </TableCell>
                          <TableCell className="attributeCheckbox">
                            <FormGroup row>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={
                                      positionAttributes[index]
                                        .displayInBookingTable
                                    }
                                    color="secondary"
                                    onChange={() =>
                                      this.handleDisplayInBookingTableChange(
                                        index
                                      )
                                    }
                                  />
                                }
                              />
                            </FormGroup>
                          </TableCell>
                          <TableCell>
                            <Button onClick={() => this.showDeleteModal(index)}>
                              <ClearIcon />
                            </Button>
                            <GenericDeleteModal
                              showModal={showDeleteModal}
                              noSelectionTitle={i18n.t(
                                'setting:warningAttributeModal'
                              )}
                              confirmMessage={`${i18n.t(
                                'setting:confirmDeleteAttribute'
                              )}: ${localeAttributeName}?`}
                              selectedId={deleteIndex}
                              onClose={this.hideDeleteModal}
                              onDelete={() => this.handleDeleteRow(deleteIndex)}
                            />
                          </TableCell>
                        </TableRow>
                      </React.Fragment>
                  )})
                }
                </TableBody>
              </Table>
              <br />
              <Button
                className="ssenseButton ssenseSecondary"
                onClick={this.handleAddNewRow}
              >
                {i18n.t('setting:addNewRow')}
              </Button>
              <Button
                className="ssenseButton ssensePrimary"
                onClick={this.onSubmit}
              >
                {i18n.t('save')}
              </Button>
              <Button
                className="ssenseButton ssenseDefault"
                onClick={this.handleCancelEdit}
              >
                {i18n.t('cancel')}
              </Button>

              <GenericWarningModal
                showWarningModal={showWarningModal}
                hideWarningModal={this.hideWarningModal}
                message={i18n.t('setting:warningEmpty')}
              />
            </div>
          )}
        </Paper>
      </Modal>
    );
  }
}

EditAttributeModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  hideModal: PropTypes.func.isRequired,
  selectedValidPosition: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  positionAttributeData: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.array
    ])
  ).isRequired,
  editAttribute: PropTypes.func.isRequired,
};

export default EditAttributeModal;
